<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-last_name"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "LastName",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('last_name')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultLabel: this.$t("Last Name")
    }
  }
}
</script>

<style scoped>

</style>
